import { TournamentId } from '@store/modules/ui/sportOffer/marketFilters/types';

export function getUniqueTournamentId(
    prefix: string,
    tournamentId: TournamentId,
    isLive: boolean,
): string {
    const statePrefix = isLive ? 'live' : 'prematch';
    return [
        prefix,
        statePrefix,
        tournamentId,
    ].join('-');
}
